/* eslint-disable */
export default {
  dialPlaceholder: 'Entrez un nom ou un numéro',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
